import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, map } from 'rxjs';

export interface DeployModelRequest {
  llmModel: string;
  language: string;
  extractionDefaultValue: string | null;
  extractionDefaultProbability: number;
  ocrType: string;
  textType: string;
  ocrCrop: boolean;
  ocrSort: boolean;
  autoCut: boolean;
  enhanceDocument: boolean;
  splitPdf: boolean;
  layoutAnalysis: string;
  adjustRotation: string;
}

export interface DeploymentHistoryEntry {
  id: string;
  model_id: string;
  created_at: string;
  snapshot: any;
  user: string;
  is_active: boolean;
}

export interface DeploymentHistoryResponse {
  message: string;
  deployments: DeploymentHistoryEntry[];
}

@Injectable({ providedIn: 'root' })
export class DeploymentsService {
  private baseUrl = '/api/deployments/';

  constructor(private http: HttpClient) {}

  deploy(modelId: string, data: DeployModelRequest): Observable<any> {
    return this.http.post(`${this.baseUrl}${modelId}/deploy`, data);
  }

  getHistory(modelId: string): Observable<DeploymentHistoryEntry[]> {
    return this.http.get<DeploymentHistoryResponse>(`${this.baseUrl}${modelId}/history`).pipe(
      map(res => res.deployments)
    );
  }

  revert(modelId: string, deploymentId: string): Observable<any> {
    return this.http.post(`${this.baseUrl}${modelId}/revert/${deploymentId}`, {});
  }
}
